import index from './scheduler_log.vue';

export default index;
